<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
    <mat-label>{{data.content}}</mat-label>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onDismiss(false)">No</button>
  <button mat-raised-button (click)="onDismiss(true)">Yes</button>
</mat-dialog-actions>
